import React from 'react';

const SenderIcon = ({ ...rest }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="#141516" {...rest}>
      <path d="M2 7.14315V16.8601C2 17.1463 2.16817 17.408 2.43441 17.536L11.5537 21.9202C11.7731 22.0257 12.031 22.0266 12.2511 21.9228L21.5601 17.5345C21.8293 17.4076 22 17.1444 22 16.856V7.1407C22 6.85406 21.8313 6.5921 21.5645 6.46432L12.4072 2.07924C12.1877 1.97414 11.9298 1.97356 11.7099 2.07767L8.63202 3.53426L17.9528 8.18412V13.3223L15.6346 14.4935V9.39311L6.19722 4.68653L2.43882 6.4652C2.17016 6.59234 2 6.85524 2 7.14315Z" />
    </svg>
  );
};

export default SenderIcon;